import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useSavedQueryByEnvironment } from '../discovery/savedQuery';
import { useEnvironmentScope } from '../useEnvironmentScope';

export type SavedQueryResult = ReturnType<typeof useSavedQuery>['data'];

export const useSavedQuery = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;
  const { userId } = useEnvironmentScope();

  const [{ fetching, error, data }] = useSavedQueryByEnvironment({
    environmentId: validEnvironmentId,
    uniqueId: uniqueId?.raw ?? '',
    userId,
    pause: uniqueId?.resourceType !== 'saved_query' || userId === 'loading',
  });

  const savedQueryQuery = useMemo(() => {
    const definitionEdge = data?.environment.definition?.savedQueries.edges?.[0];
    return {
      fetching,
      error,
      data: { applied: undefined, definition: definitionEdge?.node },
    };
  }, [fetching, error, data]);

  return savedQueryQuery;
};
